/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateTable = /* GraphQL */ `
  subscription OnCreateTable {
    onCreateTable {
      No
      describe
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateTable = /* GraphQL */ `
  subscription OnUpdateTable {
    onUpdateTable {
      No
      describe
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteTable = /* GraphQL */ `
  subscription OnDeleteTable {
    onDeleteTable {
      No
      describe
      createdAt
      updatedAt
    }
  }
`;
export const onCreateMenu = /* GraphQL */ `
  subscription OnCreateMenu {
    onCreateMenu {
      id
      name
      description
      price
      photo
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateMenu = /* GraphQL */ `
  subscription OnUpdateMenu {
    onUpdateMenu {
      id
      name
      description
      price
      photo
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteMenu = /* GraphQL */ `
  subscription OnDeleteMenu {
    onDeleteMenu {
      id
      name
      description
      price
      photo
      createdAt
      updatedAt
    }
  }
`;
export const onCreateOrder = /* GraphQL */ `
  subscription OnCreateOrder {
    onCreateOrder {
      id
      tableNo
      createdAt
      status
      updatedAt
    }
  }
`;
export const onUpdateOrder = /* GraphQL */ `
  subscription OnUpdateOrder {
    onUpdateOrder {
      id
      tableNo
      createdAt
      status
      updatedAt
    }
  }
`;
export const onDeleteOrder = /* GraphQL */ `
  subscription OnDeleteOrder {
    onDeleteOrder {
      id
      tableNo
      createdAt
      status
      updatedAt
    }
  }
`;
export const onCreateOrderDetail = /* GraphQL */ `
  subscription OnCreateOrderDetail {
    onCreateOrderDetail {
      id
      orderId
      status
      createdAt
      menuId
      menuName
      price
      count
      updatedAt
    }
  }
`;
export const onUpdateOrderDetail = /* GraphQL */ `
  subscription OnUpdateOrderDetail {
    onUpdateOrderDetail {
      id
      orderId
      status
      createdAt
      menuId
      menuName
      price
      count
      updatedAt
    }
  }
`;
export const onDeleteOrderDetail = /* GraphQL */ `
  subscription OnDeleteOrderDetail {
    onDeleteOrderDetail {
      id
      orderId
      status
      createdAt
      menuId
      menuName
      price
      count
      updatedAt
    }
  }
`;
